import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IconsModule } from "../icons/icons.module";
import { LaunchCountdownDigitComponentModule } from "../launch-countdown-digit/launch-countdown-digit.component.module";
import { LaunchCountdownComponent } from "./launch-countdown.component";

@NgModule({
  imports: [
    // Common
    CommonModule,
    LaunchCountdownDigitComponentModule,
    IconsModule
  ],
  declarations: [LaunchCountdownComponent],
  exports: [LaunchCountdownComponent],
})
export class LaunchCountdownComponentModule { }
